import React from "react";
import { filterRequestsForPlanning } from "utils/planningLeaveHelpers";
import type { LeaveRequest } from "api/leave/Leave.typed";
import type { ExcursionBooking } from "api/excursions/Excursion.typed";

export function usePlanningDayLookups(
  requests: LeaveRequest[],
  bookings: ExcursionBooking[],
  canShowPlanningFilters: boolean,
  selectedUserId: number,
) {
  const getRequestsForDay = React.useCallback(
    (date: Date): LeaveRequest[] => {
      if (!requests?.length) return [];
      const filtered = filterRequestsForPlanning(requests);
      const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
      return filtered.filter((request) => {
        if (canShowPlanningFilters && selectedUserId > 0 && request.user_id !== selectedUserId) {
          return false;
        }

        const startDate = new Date(request.start_date);
        const endDate = new Date(request.end_date);
        return utcDate >= startDate && utcDate <= endDate;
      });
    },
    [requests, canShowPlanningFilters, selectedUserId],
  );

  const getBookingsForDay = React.useCallback(
    (date: Date): ExcursionBooking[] => {
      if (!bookings?.length) return [];
      const key = `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
      let dayBookings = bookings.filter((b) => b.date?.slice(0, 10) === key);
      if (canShowPlanningFilters && selectedUserId > 0) {
        dayBookings = dayBookings.filter((b) => b.user_id === selectedUserId);
      }
      return dayBookings;
    },
    [bookings, canShowPlanningFilters, selectedUserId],
  );

  return { getRequestsForDay, getBookingsForDay };
}
